// extracted by mini-css-extract-plugin
module.exports = {"photoChooser":"PhotoChooser_photoChooser__2Qpzr","photoOptions":"PhotoChooser_photoOptions__2VrNm","selected":"PhotoChooser_selected__2bLoz","photo":"PhotoChooser_photo__3YxGI"};